import { useMemo } from 'react';
import { searchTeams, sortTeams } from '../../../../utils/casaUtils';
import { casaConstants } from '../../../../constants/globalConstant';
/**
 * Custom hook to handle teams filtering and sorting
 * @param {Array} teamsData - Array of team data
 * @param {Object} defaultTeam - Default team data
 * @param {string} searchTerm - Search term
 * @param {string} sortBy - Sort criteria
 * @param {Object} teamsMappedWithTeamId - Teams mapped by teamId
 * @returns {Array} Filtered and sorted teams
 */
export function useTeamsFilters(teamsData, defaultTeam, searchTerm, sortBy, teamsMappedWithTeamId) {
  return useMemo(() => {
    let filtered = searchTeams(teamsData, searchTerm, teamsMappedWithTeamId);

    // Filter for recently modified
    if (sortBy === casaConstants.RECENTLY_MODIFIED) {
      filtered = filtered.filter((item) => {
        // Support both mobile (homepages) and web (dashboards) data structures
        const hasHomepages = item.homepages && item.homepages.length !== 0;
        const hasDashboards = item.dashboards && item.dashboards.length !== 0;
        const hasMenu = item.menu !== undefined;
        const hasLauncher = item.launcher !== undefined;
        const hasAnnouncement = item.announcement !== undefined;

        return hasHomepages || hasDashboards || hasMenu || hasLauncher || hasAnnouncement;
      });
    }

    // Sort teams
    filtered = sortTeams(filtered, sortBy, teamsMappedWithTeamId);

    // Prepend default team
    return [defaultTeam, ...filtered];
  }, [teamsData, defaultTeam, searchTerm, sortBy, teamsMappedWithTeamId]);
}
